module.exports = __webpack_public_path__ + "static/media/hompage5.005117b0.jpg";